import { __assign, __rest } from "tslib";
import React from 'react';
import { Checkbox } from '@mercell/checkbox-react';
import { components } from 'react-select';
import { twMerge } from 'tailwind-merge';
export var CustomOption = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var className = props.className, isMulti = props.isMulti, isSelected = props.isSelected, data = props.data, label = props.label, isDisabled = props.isDisabled;
    var updatedClassName = twMerge('my-2', 'break-words', 'text-body', className, data === null || data === void 0 ? void 0 : data.className);
    var style = {
        wordBreak: 'break-word',
    };
    var returnChildren = children;
    if (isMulti) {
        returnChildren = (React.createElement(Checkbox, { id: "".concat(label, "-checkbox"), checked: isSelected, disabled: isDisabled, "aria-disabled": isDisabled, onChange: function () { return null; }, labelProps: { htmlFor: '' } }, label));
    }
    return (React.createElement(components.Option, __assign({}, props, { className: updatedClassName, innerProps: __assign(__assign({}, props.innerProps), { style: style }) }), returnChildren));
};
